import { Header } from "@/components/universal/header";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { InventoryTable } from "./-inventory-table";
import { MassAdjustmentModal } from "../-mass-adjustment-modal";
import { ClipboardList, Plus, ShieldMinus } from "lucide-react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { MassDisposalModal } from "./-mass-disposal-modal";

export const Route = createFileRoute(
  "/_private/_inventory-360/inventory/lookup/",
)({
  component: InventoryLookup,
});

function InventoryLookup() {
  return (
    <div>
      <title>Inventory - Legrande Health Portal</title>
      <Header
        crumbs={[{ name: "Inventory", link: { to: "/inventory/lookup" } }]}
      />
      <Card>
        <CardHeader>
          <CardTitle>Inventory</CardTitle>
          <CardDescription>
            View inventory items across practices. Click on an item to see
            batches and transaction history.
          </CardDescription>
          <CardAction>
            <div className="flex gap-2">
              <MassDisposalModal
                trigger={
                  <Button variant="outline" size="sm">
                    <ShieldMinus />
                    Mass Disposal
                  </Button>
                }
              />
              <MassAdjustmentModal
                trigger={
                  <Button variant="outline" size="sm">
                    <ClipboardList />
                    Mass Adjustment
                  </Button>
                }
              />
              <Button variant="default" size="sm" asChild>
                <Link to="/inventory/create">
                  <Plus />
                  Add to Inventory
                </Link>
              </Button>
            </div>
          </CardAction>
        </CardHeader>
        <CardContent>
          <InventoryTable />
        </CardContent>
      </Card>
    </div>
  );
}
